/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import { signal } from '@preact/signals-react';

export const isFormLoading = signal(false);
export const isIbanValid = signal(false);
export const voucherMessage = signal(null);
export const isVoucherValid = signal(false);
export const previewData = signal(null);
export const studio = signal(null);
export const nextButtonActive = signal(true);
